import {Taak, TaakDto, TaakType} from './taak';
import {ClientCategorie} from '../client/client-categorie';
import {Prestatie} from '../prestatie/prestatie';

export class Categorie {

  static deserialize(dto: CategorieDto): Categorie {
    return new Categorie(
      dto.id,
      dto.label,
      dto.icoon,
      dto.taken.map(taakDto => Taak.deserialize(taakDto)),
    );
  }

  constructor(
    private id: string,
    private label: string,
    private icoon: string,
    private taken: Array<Taak>
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getLabel(): string {
    return this.label;
  }

  getIcoon(): string {
    return this.icoon;
  }

  getTaken(): Array<Taak> {
    return this.taken;
  }

  getTaak(id: string): Taak {
    return this.taken.find(taak => taak.hasId(id));
  }

  hasTaken(): boolean {
    return this.taken.length > 0;
  }

  getTaakIds(): Array<string> {
    return this.taken.map(taak => taak.getId());
  }

  getTakenByType(taakType: TaakType): Array<Taak> {
    return this.taken.filter(taak => taak.hasType(taakType));
  }

  hasTakenOfType(taakType: TaakType): boolean {
    return this.getTakenByType(taakType).length > 0;
  }

  getStandaardTaken(): Array<Taak> {
    return this.getTakenByType('STANDAARD');
  }

  areAllTakenSelected(clientCategory: ClientCategorie): boolean {
    return !this.taken.find(taak => !clientCategory.hasTaak(taak.getId()));
  }

  areSomeTakenSelected(clientCategory: ClientCategorie): boolean {
    return this.taken.filter(taak => clientCategory.hasTaak(taak.getId())).length > 0
      && !this.areAllTakenSelected(clientCategory);
  }

  filterForClient(clientCategorie: ClientCategorie): Categorie {
    return new Categorie(
      this.getId(),
      this.getLabel(),
      this.getIcoon(),
      this.getTaken().filter(taak => clientCategorie.hasTaak(taak.getId())),
    );
  }

  filterOnTaakType(taakType: TaakType): Categorie {
    return new Categorie(
      this.getId(),
      this.getLabel(),
      this.getIcoon(),
      this.getTaken().filter(taak => taak.hasType(taakType)),
    );
  }

  filterForPrestatie(prestatie: Prestatie, dienstId: string, categorieId: string): Categorie {
    return new Categorie(
      this.getId(),
      this.getLabel(),
      this.getIcoon(),
      this.getTaken().filter(taak => prestatie.hasTaak(dienstId, categorieId, taak.getId())),
    );
  }
}

export interface CategorieDto {
  id: string;
  label: string;
  icoon: string;
  taken: Array<TaakDto>;
}
